export interface ComposerDraftInsertion {
  draft: string;
  selectionStart: number;
  selectionEnd: number;
}

const isSelectionPosition = (position: number | null | undefined): position is number => (
  Number.isInteger(position)
);

export const insertSavedPromptText = (
  draft: string,
  promptText: string,
  selectionStart?: number | null,
  selectionEnd?: number | null,
): ComposerDraftInsertion => {
  if (
    isSelectionPosition(selectionStart)
    && isSelectionPosition(selectionEnd)
    && selectionStart >= 0
    && selectionEnd >= selectionStart
    && selectionEnd <= draft.length
  ) {
    const nextDraft = `${draft.slice(0, selectionStart)}${promptText}${draft.slice(selectionEnd)}`;
    const nextCaretPosition = selectionStart + promptText.length;
    return {
      draft: nextDraft,
      selectionStart: nextCaretPosition,
      selectionEnd: nextCaretPosition,
    };
  }

  if (!draft.trim()) {
    return {
      draft: promptText,
      selectionStart: promptText.length,
      selectionEnd: promptText.length,
    };
  }

  const separator = draft.endsWith('\n') ? '\n' : '\n\n';
  const nextDraft = `${draft}${separator}${promptText}`;
  return {
    draft: nextDraft,
    selectionStart: nextDraft.length,
    selectionEnd: nextDraft.length,
  };
};